<template>
    <BaseEditPage :context="context" :alvqa="alvqa" cancelIconRoute="/az/azpersons">
        <!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center" style="margin-top: 8px;">
                <div v-if="$route.params.alvId === 'new'" class="headline" :alvqa="alvqa + '-title'">
                    {{ $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
                </div>
                <div v-else class="headline" :alvqa="alvqa + '-title'">
                    {{
                        (data.firstName !== null && data.firstName !== '') || (data.lastName !== null && data.lastName !== '') ?

                        (data.firstName !== null && data.firstName !== '' ? data.firstName : '') + (data.lastName !== null &&
                            data.lastName !== '' ? ' ' + data.lastName : '') :
                        (data.group !== null && data.group !== '') ? data.group : data.gemaName
                    }}
                </div>
                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon 
                        v-if="hasContextHelp"
                        context="AzPersonsEdit"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>
        <!-- EDIT FORM -->
        <template v-slot:editForm="{ data }">
            <!-- 1st column -->
            <v-col cols="1">
                <v-row>
                    <v-col>
                        <v-img v-if="data.pictureBig !== null" :src="data.pictureBig"></v-img>
                        <v-img v-else aspect-ratio="1" class="defaultImageEditPage" :alvqa="alvqa + '-image'">
                            <v-row class="fill-height ma-0" align="center" justify="center">
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col>

            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField :context="context" field="Group"
                        :label="$t('lang_AZ_PERSONS_CAPTION_COMPANY_GROUP_ARTIST_NAME')" :disabled="disableField"
                        :rules="isGroupRequired" :alvqa="alvqa + '-textfield-group'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Department"
                        :label="$t('lang_AZ_PERSONS_CAPTION_DEPARTMENT')" :alvqa="alvqa + '-textfield-department'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="SalutationOne"
                        :label="$t('lang_AZ_PERSONS_CAPTION_SALUTATION_ADDRESS')"
                        :alvqa="alvqa + '-textfield-salutation-one'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="FirstName"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FIRST_NAME')" :rules="areNamesRequiered"
                        :alvqa="alvqa + '-textfield-first-name'" />
                </v-row>
                <v-row class="align-center">
                    <BaseEditPageTextField :context="context" field="LastName" :withMargin="false"
                        :label="$t('lang_AZ_PERSONS_CAPTION_LAST_NAME')" :rules="areNamesRequiered"
                        :alvqa="alvqa + '-textfield-last-name'" class="ml-4" style="flex: 1;" />
                    <BaseIcon
                        icon="auto_fix_high"
                        :alvqa="alvqa + '-icon-ai-keyname'"
                        color="iconStandard"
                        small
                        class="mr-4"
                        :tooltipText="$t('lang_AZ_PERSONS_CAPTION_GENERATE_KEY_NAME')"
                        @click="onGenerateKeyName"
                    />
                </v-row>
                <v-row v-if="isJapaneseUi">
                    <BaseEditPageTextField :context="context" field="NameKatakana"
                        :label="$t('lang_AZ_PERSONS_CAPTION_NAME_KATAKANA')"
                        :alvqa="alvqa + '-textfield-name-katakana'" />
                </v-row>
                <v-row class="align-center">
                    <BaseEditPageGoogleAddressAutocomplete :context="context" field="AddressRowOne" :disabled="disableField" :withMargin="false"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                        :alvqa="alvqa + '-textfield-address-row-one'" class="ml-4" style="flex: 1;" />
                    <BaseIcon
                        icon="place"
                        :alvqa="alvqa + '-icon-google-places'"
                        color="iconStandard"
                        small
                        class="mr-4"
                        :tooltipText="$t('lang_AZ_PERSONS_CAPTION_GOOGLE_PLACES_AUTOCOMPLETE')"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="AddressRowTwo" :disabled="disableField"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                        :alvqa="alvqa + '-textfield-address-row-two'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Zip" :disabled="disableField"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')" :alvqa="alvqa + '-textfield-zip'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="City" :disabled="disableField"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')" :alvqa="alvqa + '-textfield-city'"
                        :additionalFunction="getCurrentAdress(data)" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="State" :disabled="disableField"
                        :label="$t('lang_AZ_PERSONS_CAPTION_STATE')" :alvqa="alvqa + '-textfield-state'" />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown :context="context" field="Country" :items="countries" :disabled="disableField"
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"
                        :resetValNull="true"
                        :alvqa="alvqa + '-dropdown-country'" />
                </v-row>
            </v-col>

            <!-- 3rd column  -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField :context="context" field="AlvId" :label="$t('lang_GENERIC_CAPTION_ALVID')"
                        :clearable="false" :disabled="true" :alvqa="alvqa + '-textfield-alvid'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Web" :label="$t('lang_AZ_PERSONS_CAPTION_WEB')"
                        :alvqa="alvqa + '-textfield-web'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Facebook"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FACEBOOK')" :alvqa="alvqa + '-textfield-facebook'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Twitter" :label="$t('lang_AZ_PERSONS_CAPTION_TWITTER')"
                        :alvqa="alvqa + '-textfield-twitter'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="Youtube" :label="$t('lang_AZ_PERSONS_CAPTION_YOUTUBE')"
                        :alvqa="alvqa + '-textfield-youtube'" />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown :context="context" field="FormOfAddress" :items="formOfAddressOptions"
                    :label="$t('lang_AZ_PERSONS_CAPTION_FORM_OF_ADDRESS')"
                    :alvqa="alvqa + '-dropdown-form-of-address'" />
                </v-row>
                <v-row>
                    <BaseEditPageTextField :context="context" field="SalutationTwo"
                    :label="$t('lang_AZ_PERSONS_CAPTION_SALUTATION_TEXT')"
                    :alvqa="alvqa + '-textfield-salutation-two'" />
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="input-label" style="display: flex; align-items: center; margin-bottom: 4px;">
                        <span>{{ $t('lang_AZ_PERSONS_CAPTION_TAGS') }}</span>
                        <HelpIcon
                            :urls="{
                                de: '41060331',
                                en: '192282755',
                                ko: '176881668',
                            }"
                            :tooltipText="$t('lang_GENERIC_CLICK_TO_HELP_CENTER')"
                        />
                        </div>
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="Tags" 
                            rows="7"
                            :withMargin="false"
                            class="pt-0 mt-0"
                            :alvqa="alvqa + '-textfield-tags'" 
                        />
                    </v-col>
                </v-row>

            </v-col>

            <v-col cols="5">
                <v-row>
                    <!-- 4th column -->
                    <v-col cols="6">
                        <v-row>
                            <BaseEditPageTextField :context="context" field="Phone"
                                :label="$t('lang_AZ_PERSONS_CAPTION_PHONE')" :alvqa="alvqa + '-textfield-phone'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField :context="context" field="PhonePrivate"
                                :label="$t('lang_AZ_PERSONS_CAPTION_PHONE_PRIVATE')"
                                :alvqa="alvqa + '-textfield-phone-private'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField :context="context" field="Fax" :label="$t('lang_AZ_PERSONS_CAPTION_FAX')"
                                :alvqa="alvqa + '-textfield-fax'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField :context="context" field="Cellphone"
                                :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')" :alvqa="alvqa + '-textfield-cellphone'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField :context="context" field="Email" :rules="areEmailRequired"
                                :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')" :alvqa="alvqa + '-textfield-email'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown :context="context" field="FormatNameAddress" :items="dropdownFormatNameAddress"
                            :clearable="false" :label="$t('lang_AZ_PERSONS_CAPTION_FORMAT_NAME_ADDRESS')"
                            :alvqa="alvqa + '-dropdown-format-name-address'" />
                        </v-row>
                    </v-col>

                    <!-- 5th column -->
                    <v-col cols="6">
                        <v-row>
                            <BaseEditPageTextField :context="context" field="GemaName"
                                :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_NAME')" :clearable="false" :readonly="false"
                                :loading="$store.getters.getAzPersonsKeyNameLoading"
                                :alvqa="alvqa + '-textfield-gema-name'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown :context="context" field="Dealflow" :items="dealflowItems"
                                :label="$t('lang_AZ_PERSONS_CAPTION_DEALFLOW')" :alvqa="alvqa + '-dropdown-dealflow'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown :context="context" field="Type" :items="azTypes"
                                :label="$t('lang_AZ_PERSONS_CAPTION_TYPE')" :multiple="true" :selection="true"
                                :alvqa="alvqa + '-dropdown-type'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown :context="context" field="Visibility" :items="visibilityItems"
                                :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')" :clearable=false
                                :alvqa="alvqa + '-dropdown-visibility'" />
                        </v-row>
                        <!-- API Connection -->
                        <v-row>
                            <BaseEditPageDropdown :context="context" field="Api" :items="apiConnections"
                                :label="$t('lang_GENERIC_CAPTION_API_CONNECTIONS')" :multiple="true" :selection="true"
                                :alvqa="alvqa + '-dropdown-type'" />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField :context="context" field="Labelcode"
                                :label="$t('lang_AZ_PERSONS_CAPTION_LABELCODE')" :alvqa="alvqa + '-textfield-label-code'" />
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <BaseEditPageTextarea :context="context" field="Notes" rows="8"
                        :label="$t('lang_GENERAL_CAPTION_NOTES')" :alvqa="alvqa + '-textarea-notes'" />
                </v-row>
            </v-col>
        </template>
        
        <!-- PANELS -->
        <template v-slot:panels>
            <DeletionDialog :useContextSetinVuex="true" />
            <ContextHelpDialog />
            <CommunicationListPanel />
            <CommunicationListEditDialog />
            <MetadataPanel />
            <AzPersonsMappingsPanel />
            <FinancePanel />
            <OtherIdsPanel/>
            <OtherIdsEditDialog/>
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'

import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageGoogleAddressAutocomplete from '@/components/_editForm/BaseEditPageGoogleAddressAutocomplete'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import { DropdownFormatNameAdressTypes } from '@/assets/dropdowns/alvDropdowns.js'

import MetadataPanel from './_panels/MetadataPanel'
import AzPersonsMappingsPanel from './_panels/MappingsPanel'
import FinancePanel from './_panels/FinancePanel'
import CommunicationListPanel from './_panels/CommunicationListPanel'
import CommunicationListEditDialog from './_dialogs/CommunicationListEditDialog'
import OtherIdsPanel from './_panels/OtherIdsPanel'
import OtherIdsEditDialog from './_dialogs/OtherIdsEditDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import HelpIcon from '@/components/_buttons/HelpIcon'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

export default {
    name: "AzPersonsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        HelpIcon,
        ContextHelpIcon,
        ContextHelpDialog,
        BaseEditPageTextField,
        BaseEditPageGoogleAddressAutocomplete,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
        MetadataPanel,
        AzPersonsMappingsPanel,
        FinancePanel,
        CommunicationListPanel,
        CommunicationListEditDialog,
        OtherIdsPanel,
        OtherIdsEditDialog,
        DeletionDialog,
    },
    data() {
        return {
            context: "AzPersons",
            alvqa: "az-persons-edit-form",
            hasContextHelp: false
        }
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('AzPersonsEdit')
    },
    computed: {
        azPersonData() { return this.$store.getters.getAzPersonsDetails },
        isJapaneseUi() { return ['ja', 'jp'].includes(this.$i18n.locale) },

        // Dropdowns
        countries() {
            return this.$alvPlugin.getListOfTranslatedCountries()
        },
        disableField() {
            if (this.$store.getters.getAzPersonsInheritsDataFromGroup !== undefined) {
                return this.$store.getters.getAzPersonsInheritsDataFromGroup === true ? true : false
            }
        },
        azTypes() {
            let typesArr
            let azTypes = this.$store.getters['getAzTypes' + this.$i18n.locale.toUpperCase()]
            if (azTypes === undefined) azTypes = this.$store.getters.getAzTypesEN // fallback EN

            if (azTypes !== undefined) {
                typesArr = JSON.parse(JSON.stringify(azTypes))
                typesArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase()
                });
            } else {
                typesArr = []
            }
            typesArr.sort(function (a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            return typesArr
        },
        apiConnections() {
            let apiArr
            let apiConnections = this.$store.getters['getApiConnections']

            if (apiConnections !== undefined) {
                apiArr = JSON.parse(JSON.stringify(apiConnections))
                apiArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase();
                    element['text'] = this.$t(element.text);
                });
            } else {
                apiArr = []
            }
            apiArr.sort(function (a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            return apiArr
        },

        dealflowItems() {
            let dealflowArr
            let dealflow = this.$store.getters['getDealflow' + this.$i18n.locale.toUpperCase()]
            if (dealflow === undefined) dealflow = this.$store.getters.getDealflowEN // fallback EN

            if (dealflow !== undefined) {
                dealflowArr = JSON.parse(JSON.stringify(dealflow))
                dealflowArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-dealflow-' + element.value
                });
            } else {
                dealflowArr = []
            }

            return dealflowArr
        },
        visibilityItems() {
            let visibilityArr
            let visibility = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()]
            if (visibility === undefined) visibility = this.$store.getters.getVisibilityEN // fallback EN

            if (visibility !== undefined) {
                visibilityArr = JSON.parse(JSON.stringify(visibility))
                visibilityArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-visibility-' + element.value
                });
            } else {
                visibilityArr = []
            }
            return visibilityArr
        },

        dropdownFormatNameAddress() {
            return DropdownFormatNameAdressTypes
        },

        formOfAddressOptions() {
            return [
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_ADDRESS_FORMALLY'),
                    value: 1,
                    alvqa: this.alvqa + '-dropdown-form-of-address-formally'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_ADDRESS_INFORMALLY'),
                    value: 0,
                    alvqa: this.alvqa + '-dropdown-form-of-address-informally'
                },
            ]
        },

        isAddressedFormally: {
            get() { return this.$store.getters.getAzPersonsDetailsFormOfAdress },
            set(value) { this.$store.commit('setAzPersonsDetailsFormOfAdress', value) }
        },

        // Validation
        isGroupRequired() {
            if (
                (this.azPersonData.firstName === null ||
                    this.azPersonData.lastName === null)
            ) return 'required'
            else return ''
        },
        areNamesRequiered() {
            if (
                this.azPersonData.group === null
            ) return 'required'
            else return ''
        },
        areEmailRequired(){
            if(this.azPersonData.api !== null && this.azPersonData.api !== undefined){
                if(this.azPersonData.api.includes('mailchimp') || this.azPersonData.api.includes('helpjuice')){
                    return 'required'
                }
            }
            return ''
        }
    },
    methods: {
        uploadPicture() {
            console.log('Upload Pic')
        },
        async onGenerateKeyName() {
            const first = this.$store.getters.getAzPersonsDetailsFirstName
            const last  = this.$store.getters.getAzPersonsDetailsLastName
            if ((!first || first === '') || (!last || last === '')) {
                this.$store.commit('setSnackbar', { type: 'error', msg: this.$t('lang_AZ_PERSONS_MESSAGE_MISSING_NAMES') })
                return
            }
            
            // Frontend validation - check for Japanese or Korean characters in last name
            const hasHiragana = /[\u3040-\u309F]/.test(last)
            const hasKatakana = /[\u30A0-\u30FF]/.test(last)
            const hasKanji = /[\u4E00-\u9FAF]/.test(last)
            const hasHangul = /[\uAC00-\uD7AF\u1100-\u11FF]/.test(last)
            
            if (!hasHiragana && !hasKatakana && !hasKanji && !hasHangul) {
                this.$store.commit('setSnackbar', { type: 'error', msg: this.$t('lang_GENERIC_MESSAGE_AI_ERROR_JAPANESE_KOREAN_ONLY') })
                return
            }
            
            const result = await this.$store.dispatch('fetchAzPersonsKeyNameFromAi', { firstName: first || '', lastName: last || '' })
            if (result && result.error && result.errorMsg) {
                this.$store.commit('setSnackbar', { type: 'error', msg: result.errorMsg })
            } else if (result && result.formattedKeyName) {
                this.$store.commit('setAzPersonsDetailsGemaName', result.formattedKeyName)
                this.$store.commit('setSnackbar', { type: 'success', msg: this.$t('lang_AZ_PERSONS_SNACKBAR_KEY_NAME_GENERATED') })
            }
        },
        getCurrentAdress(data) {
            if (data !== null || data !== undefined) {
                if ((data.inheritFromGroupObject !== null || data.inheritFromGroupObject !== undefined) && data.inheritFromGroup === true) {
                    this.$store.commit("setAzPersonsDetailsAddressRowOne", data.inheritFromGroupObject.inv_address)
                    this.$store.commit("setAzPersonsDetailsAddressRowTwo", data.inheritFromGroupObject.inv_address2)
                    this.$store.commit("setAzPersonsDetailsZip", data.inheritFromGroupObject.inv_zip)
                    this.$store.commit("setAzPersonsDetailsCity", data.inheritFromGroupObject.inv_city)
                    this.$store.commit("setAzPersonsDetailsCountry", data.inheritFromGroupObject.inv_land)
                    this.$store.commit("setAzPersonsDetailsState", data.inheritFromGroupObject.state)
                }
            }
        }
    },
    mounted() {
        this.$store.commit('setCountries')
        this.$store.commit('setVisibility')
        this.$store.commit('setDealflow')
        this.$store.commit('setAzTypes')
        this.$store.commit('setApiConnections')
    },
}
</script>